export const API_INBOXES_PATH = 'api/landlord/conversations/inboxes';
export const API_INBOX_FAVORITES_PATH = 'api/landlord/conversations/inboxes/favorites';
